<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" text="Vissza"></ion-back-button>
    </ion-buttons>
    <ion-title>Adatkezelés</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="adatkezeles">
  <main class="lap">
    <h1>Adatkezelési szabályzat és tájékoztató</h1>
    <p>
      Az iskola a tanulók, a szülők és a munkatársak személyes adatait az adatkezelési szabályzatában
      foglaltak szerint kezeli. A szabályzatot és – ha az intézmény külön készített ilyet – a szülőknek,
      tanulóknak szóló adatkezelési tájékoztatót itt, belépés nélkül is elolvashatod.
    </p>

    <p class="halvany" *ngIf="fut">Betöltés…</p>
    <p class="hiba" role="alert" *ngIf="hiba">{{ hiba }}</p>

    <p *ngIf="!fut && !hiba && !intezmenyek.length">
      Az intézmény még nem töltötte fel az adatkezelési szabályzatát a rendszerbe. Addig az iskola
      titkárságán vagy az iskola honlapján kérheted el.
    </p>

    <section *ngFor="let i of intezmenyek" [attr.aria-label]="i.nev">
      <h2>{{ i.nev }}</h2>
      <ul class="dokok">
        <li *ngFor="let d of i.dokumentumok">
          <a [href]="href(d)" target="_blank" rel="noopener">
            {{ d.cim }}<span class="sr-only"> (PDF, új ablakban nyílik)</span>
          </a>
          <span class="halvany">
            – PDF<span *ngIf="meret(d.meret)">, {{ meret(d.meret) }}</span><span
              *ngIf="d.hatalyos_tol">, hatályos: {{ datum(d.hatalyos_tol) }}</span><span
              *ngIf="!d.hatalyos_tol && d.feltoltve">, közzétéve: {{ datum(d.feltoltve) }}</span>
          </span>
        </li>
      </ul>
    </section>

    <p class="halvany lablec">
      Az adatkezeléssel kapcsolatos kérdéseiddel, kérelmeiddel (pl. hozzáférés, helyesbítés) az iskolához
      vagy az iskola adatvédelmi tisztviselőjéhez fordulhatsz – az elérhetőség a szabályzatban szerepel.
      <a routerLink="/akadalymentesseg">Akadálymentesítési nyilatkozat</a>
    </p>
  </main>
</ion-content>
